import { render, staticRenderFns } from "./CompanyDataBox.vue?vue&type=template&id=46d17f8d&"
import script from "./CompanyDataBox.vue?vue&type=script&lang=js&"
export * from "./CompanyDataBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports